var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.398 12.809a1.041 1.041 0 0 0 1.204-.003c.178-.13.313-.31.387-.518l.447-1.373a2.337 2.337 0 0 1 1.477-1.479l1.39-.45a1.045 1.045 0 0 0-.043-1.98l-1.375-.448a2.335 2.335 0 0 1-1.48-1.477l-.452-1.388a1.044 1.044 0 0 0-1.973.017l-.457 1.4a2.336 2.336 0 0 1-1.44 1.45l-1.39.447a1.045 1.045 0 0 0 .016 1.974l1.374.445a2.333 2.333 0 0 1 1.48 1.488l.453 1.39c.072.205.206.38.382.505Zm.085-7.415.527-1.377.44 1.377a3.331 3.331 0 0 0 2.117 2.114l1.406.53-1.382.447a3.344 3.344 0 0 0-2.115 2.117l-.523 1.378-.45-1.38a3.336 3.336 0 0 0-.8-1.309 3.373 3.373 0 0 0-1.311-.812l-1.378-.522 1.386-.45a3.358 3.358 0 0 0 1.29-.813 3.4 3.4 0 0 0 .793-1.3Zm6.052 11.457a.805.805 0 0 0 1.226-.398l.248-.762a1.08 1.08 0 0 1 .68-.68l.772-.252a.8.8 0 0 0-.023-1.52l-.764-.25a1.074 1.074 0 0 1-.68-.678l-.252-.773a.8.8 0 0 0-1.518.01l-.247.762a1.067 1.067 0 0 1-.665.679l-.773.252a.8.8 0 0 0 .008 1.518l.763.247a1.059 1.059 0 0 1 .68.683l.253.774a.8.8 0 0 0 .292.388Zm-.913-2.793-.18-.058.185-.064a2.11 2.11 0 0 0 1.3-1.317l.058-.178.06.18a2.077 2.077 0 0 0 1.316 1.317l.195.063-.18.06a2.077 2.077 0 0 0-1.317 1.32l-.06.18-.057-.18a2.075 2.075 0 0 0-1.32-1.322"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.17d9f11cf5bf9cfe25eef3f658f2a7b8.svg";
export { ForwardRef as ReactComponent };